<template>
  <div class="th-wishlist-saya">
    <h2 class="th-title">Wishlist Saya</h2>
    <div
      style="height: 50vh"
      class="flex justify-center items-center"
      v-if="!wishlists.length"
    >
      Belum ada wishlist.
    </div>
    <div class="grid lg:grid-cols-3 gap-4">
      <div v-for="(course, i) in wishlists" :key="i">
        <CardCourse
          :content="course"
          :dataIsWishlist="course.isWishlist"
          @fetchWishlist="fetchWishlist"
        />
      </div>
    </div>
  </div>
</template>

<script>
const CardCourse = () => import('@/components/Shared/CardCourse/1')
export default {
  components: { CardCourse },
  data() {
    return {
      wishlists: [],
    }
  },
  methods: {
    async fetchWishlist() {
      try {
        const dataWishlists = await this.$store.dispatch('course/FETCH_MY_WISHLIST')
        this.wishlists = dataWishlists.map(data => {
          return {
            ...data,
            title: data.name,
            instructor: data.vendor.firstName + ' ' + data.vendor.lastName,
            type: data.type,
            price: data.price,
            key: data._id,
            rating: data.averageRating,
            isWishlist: true,
          }
        })
      } catch (err) {
        console.log(err)
      }
    },
  },
  created() {
    this.fetchWishlist()
  },
}
</script>

<style lang="scss">
.th-wishlist-saya {
  .container-card-course-1 {
    width: 100%;
    max-width: 460px;
  }
}
</style>
